.mapping-list-wrapper {
  width: 50%;
}
